module.exports = __webpack_public_path__ + "static/sf-ui-bold-cf233a009c79af3c782b5ceb4a16905d.eot";